export default __webpack_public_path__ + "static/home-right-img-5aaaa0a2ca2e689eabfa723ec4eb48dc.png";